type SideBarPage = "search" | "category" | "filter" | "detail";

class StateStore {
  activePage = $state<SideBarPage | null>(null);
  sidebaropen = $derived<boolean>(this.activePage !== null);
  prevPage = $state<SideBarPage | null>(null);

  appInstallDialog = $state(false);
  appInstallTitle = $state("");
  appInstallDesc = $state("");

  openAppInstall(title: string, desc: string) {
    this.appInstallTitle = title;
    this.appInstallDesc = desc;
    this.appInstallDialog = true;
  }

  toggleCategory() {
    if (this.activePage === "category") {
      if (this.prevPage === "search" || this.prevPage === "detail") {
        this.activePage = this.prevPage;
        this.prevPage = null;
        return;
      }
      this.activePage = null;
      this.prevPage = null;
      return;
    }

    if (this.activePage === "search" || this.activePage === "detail") {
      this.prevPage = this.activePage;
    }

    this.activePage = "category";
  }

  toggleFilter() {
    if (this.activePage === "filter") {
      if (this.prevPage === "search" || this.prevPage === "detail") {
        this.activePage = this.prevPage;
        this.prevPage = null;
        return;
      }
      this.activePage = null;
      this.prevPage = null;
      return;
    }

    if (this.activePage === "search" || this.activePage === "detail") {
      this.prevPage = this.activePage;
    }

    this.activePage = "filter";
  }

  openSearch() {
    this.prevPage = null;
    this.activePage = "search";
  }

  openDetail() {
    if (this.activePage === "search") {
      this.prevPage = this.activePage;
    }

    this.activePage = "detail";
  }

  closeDetail() {
    this.activePage = this.prevPage ? this.prevPage : null;
    this.prevPage = null;
  }
}

export const stateStore = new StateStore();
